<template>
    <ToolButton :Editor="Editor" KnownIcon="CodeView" @ToolClick="ToggleCodeBlock()">
        
    </ToolButton>
</template>
<script>

import ToolButton from '@/views/components/atoms/tiptap/Predefined/Buttons/ToolButton.vue';

export default ({
    data(){
        return {
            IsSourceView: false
        }
    },
    components: {
        ToolButton
    },
    methods:{
        ToggleCodeBlock(){
            if (this.Editor) {
                this.Editor.commands.toggleCodeBlock();
            }
        }
    },
    props: ["Editor"]
});
</script>